import styled, { css } from 'styled-components/macro'

export const PageWrapper = styled.main`
  max-width: 1500px;
  margin: 0 auto;
  padding: 24px 32px 48px;
`

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`

export const NewMaterialButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #308143;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: #154822;
  }
`

export const BannerRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const BannerWelcome = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: #f9f9f9;
  border-radius: 12px;
  padding: 20px 24px;

  strong {
    display: block;
    margin-bottom: 6px;
  }

  p {
    color: #444;
    line-height: 1.5;
  }
`

export const BannerInfo = styled.div`
  width: 300px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #eff6ff;
  border-radius: 12px;
  padding: 20px 24px;

  p {
    color: #1e40af;
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    width: auto;
  }
`

export const ListagemContentArea = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
`

export const Sidebar = styled.aside`
  width: 270px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const SidebarTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
`

export const ClearFiltersBtn = styled.button`
  background: none;
  border: none;
  color: #16a34a;
  font-size: 13px;
  cursor: pointer;
`

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label:first-child {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
  }
`

export const Select = styled.select`
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background: #fff;
  cursor: pointer;
  padding-right: 28px;

  &:disabled {
    background-color: #f3f4f6;
    color: #9ca3af;
  }
`

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
`

export const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
`

export const ApplyFiltersBtn = styled.button`
  padding: 11px;
  background: #308143;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 4px;

  &:hover {
    background: #154822;
  }
`

export const TableArea = styled.div`
  flex: 1;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
`

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const TableTitle = styled.h2`
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
`

export const SortRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6b7280;
`

export const Th = styled.th`
  text-align: left;
  padding: 10px 12px;
  color: #6b7280;
  font-weight: 600;
  font-size: 13px;
  border: 1px solid #e5e7eb;
`

export const Td = styled.td`
  padding: 12px 12px;
  color: #374151;
  vertical-align: middle;
  font-size: 13px;
  border: 1px solid #e5e7eb;
`

export const DocNameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const IconBackground = styled.div`
  border-radius: 10%;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;

export const TipoBadge = styled.span<{ $tipo?: number }>`
  padding: 3px 10px;
  font-size: 12px;
  border-radius: 5px;
  white-space: nowrap;

  ${({ $tipo }) => {
    if ($tipo === 1) {
      return css`
        background: #fce7f3;
        color: #be185d;
      `
    }

    if ($tipo === 2) {
      return css`
        background: #ede9fe;
        color: #6d28d9;
      `
    }

    if ($tipo === 4) {
      return css`
        background: #E2F0D8;
        color: #0B5D1E;
      `
    }
  }}
`

export const ActionsCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const DownloadBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 7px;
  padding: 7px 14px;
  border: 1.5px solid #16a34a;
  background: #fff;
  color: #16a34a;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f0fdf4;
  }
`

export const MenuBtn = styled.button`
  border: 1.5px solid #16a34a;
  border-radius: 7px;
  background: #fff;
  font-size: 20px;
  color: #16a34a;
  cursor: pointer;
  padding: 4px 8px;
  line-height: 1;

  &:hover {
    background: #f3f4f6;
  }
`

export const DropdownMenu = styled.div`
  position: absolute;
  right: 0px;
  top: calc(100% + 4px);
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 100;
  min-width: 130px;
`

export const DropdownItem = styled.button<{ $danger?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 16px;
  background: none;
  border: none;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  color: ${({ $danger }) => ($danger ? '#dc2626' : '#374151')};

  &:hover {
    background: ${({ $danger }) => ($danger ? '#fef2f2' : '#f9fafb')};
  }
`

export const LoadingText = styled.p`
  text-align: center;
  color: #6b7280;
  padding: 40px 0;
`

export const EmptyState = styled.p`
  text-align: center;
  color: #9ca3af;
  padding: 40px 0;
`

export const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  gap: 24px;
`

export const FormCard = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 32px 40px;
  max-width: 960px;
  margin: 0 auto;
`

export const FormTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 4px;
`

export const FormSubtitle = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 28px;
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 24px;
`

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #374151;
`

export const FormInput = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  padding: 11px 14px;
  border: 1.5px solid ${({ $hasError }) => ($hasError ? '#dc2626' : '#d1d5db')};
  border-radius: 8px;
  font-size: 14px;
  color: #1a1a1a;
  box-sizing: border-box;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: ${({ $hasError }) => ($hasError ? '#dc2626' : '#16a34a')};
    box-shadow: 0 0 0 3px ${({ $hasError }) =>
      $hasError ? 'rgba(220,38,38,0.1)' : 'rgba(22,163,74,0.1)'};
  }
`

export const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

export const StyledCheckbox = styled.input`
  width: 18px;
  height: 18px;
  accent-color: #16a34a;
  cursor: pointer;
`

export const ColorSwatch = styled.button<{ $color: string; $selected: boolean }>`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background-color: ${({ $color }) => $color};
  border: ${({ $selected }) => ($selected ? '3px solid #1a1a1a' : '3px solid transparent')};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DropContainer = styled.div<{ $dragging: boolean; $hasError?: boolean }>`
  border: 2px dashed
    ${({ $hasError, $dragging }) =>
      $hasError ? '#dc2626' : $dragging ? '#16a34a' : '#86efac'};
  border-radius: 10px;
  padding: 16px;
  background: ${({ $dragging }) => ($dragging ? '#f0fdf4' : '#fff')};
`

export const AnexoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: #f9fafb;
  border-radius: 8px;
  margin-bottom: 16px;
`

export const AnexoIcon = styled.span`
  background: #dc2626;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 6px;
  border-radius: 4px;
`

export const AnexoInfo = styled.div`
  flex: 1;

  span {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #1a1a1a;
  }

  small {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: #6b7280;
  }
`

export const AnexoBtn = styled.button`
  background: none;
  border: 1.5px solid #16a34a;
  color: #16a34a;
  border-radius: 6px;
  padding: 5px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #f0fdf4;
  }
`

export const AnexoDeleteBtn = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;

  &:hover {
    background: #fef2f2;
  }
`

export const DropContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 0 8px;
`

export const SelectFileBtn = styled.button`
  padding: 8px 20px;
  border: 1.5px solid #16a34a;
  background: #fff;
  color: #16a34a;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f0fdf4;
  }
`

export const DropHint = styled.p`
  font-size: 12px !important;
  color: #9ca3af !important;
  text-align: center;
  line-height: 1.5;
  margin-top: 4px !important;

  strong {
    color: #16a34a;
  }
`

export const FormBtns = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
  padding-top: 24px;
  border-top: 1px solid #f3f4f6;
`

export const CancelBtn = styled.button`
  padding: 10px 28px;
  background: #fff;
  border: 1.5px solid #d1d5db;
  color: #374151;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    border-color: #9ca3af;
  }
`

export const SaveBtn = styled.button`
  padding: 10px 28px;
  background: #1a5c2a;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #154822;
  }
`

export const ErrorMsg = styled.span`
  font-size: 12px;
  color: #dc2626;
`